import { TStandingType } from '../../../store/admin/eventAwards/store';
import { ISeasonAward } from '../../../store/admin/seasonAwards/store';

export const getStandingAmount = (award: ISeasonAward, standingType: TStandingType) =>
  standingType
    ? `${standingType === 'cash' || standingType === 'scrip' ? '$' : ''}${award[standingType]}`
    : '';
